import useSWR from 'swr';

export interface CryptoRelatedEventPolymarket {
  polymarket_id: string;
  slug: string;
  polymarket_title: string;
  end_date: string | null;
}

export interface CryptoRelatedEvent {
  event_id: string | null;
  polymarket_id?: string | null;
  title: string;
  summary: string | null;
  event_time_start: string | null;
  image_url: string | null;
  importance_score: number | string | null;
  event_type: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  slug?: string;
  polymarket_title?: string;
  end_date?: string | null;
  polymarkets?: CryptoRelatedEventPolymarket[];
}

export interface CryptoRelatedEventResponse {
  symbol: string;
  events: CryptoRelatedEvent[];
}

export function useCryptoRelatedEvent(symbol: string) {
  return useSWR<CryptoRelatedEventResponse>(
    symbol ? `api:/market/crypto/${symbol.toLowerCase()}/relate-event` : null,
  );
}
